import { PathUtils } from '@adobe/aem-spa-page-model-manager';
import axios, { AxiosResponse } from 'axios';
import API_MAPPING from '../../utils/api-utils/acquisition-api-map';
import SessionStorage from '../../utils/SessionStorage';

const hostNames = {
    DEV: 'https://card-acquisitions-dev.creditone.com',
    SIT: 'https://card-acquisitions-sit.creditone.com',
    UAT: 'https://card-acquisitions-uat.creditone.com',
    HF: 'https://card-acquisitions-hf.creditone.com',
    PROD: 'https://card-acquisitions.creditonebank.com',
};

const bffPath = '/public/enterprise/accounts-acquisitions/v1/aem-accounts-acquisitions-bff';
const mockApiResponsesEnabled = process.env.REACT_APP_NODE_ENV === 'development'
    || process.env.NODE_ENV !== 'production';

export const callAcquisitionBff = async <T>(
    name: keyof typeof API_MAPPING, 
    options?: {
        append?: string,
        body?: Record<string, any>,
        replace?: Record<string, string>,
        headers?: Record<string, any>,
    },
) : Promise<AxiosResponse<T, any>> => {
    const useMock = mockApiResponsesEnabled
        && (window.location.host.indexOf('4502') > -1
            || SessionStorage.tryGet('offerId', '').startsWith('test'));
    if (useMock) {
        const endpoint = API_MAPPING[name] as any;
        if (endpoint.getMockResponse) {
            const searchParams = new URLSearchParams(window.location.search);
            const mockResponse = endpoint.getMockResponse(searchParams);
            if (mockResponse.status >= 400) {
                return Promise.reject(mockResponse);
            }
            return Promise.resolve(mockResponse);
        }
        return Promise.resolve(endpoint.mock);
    }

    const currentAcquisitionEnvironment = PathUtils.getMetaPropertyValue('acquisitionEnvironment');
    const currentUri = hostNames[currentAcquisitionEnvironment] + bffPath;

    const currentMethod = API_MAPPING[name].method;
    let apiPath = API_MAPPING[name].endpoint;

    if (options?.replace) {
        Object.entries(options.replace).forEach(([key, value]) => {
            apiPath = apiPath.replace(`{${key}}`, value);
        });
    }

    if (options?.append) {
        apiPath = `${apiPath}${options.append}`;
    }

    return await axios.request<T>({ 
        method: currentMethod,
        url: currentUri + apiPath, 
        data: options?.body, 
        headers: options?.headers,
    });
};